import React from 'react';
import PropTypes from 'prop-types';

import './EmptyMessage.scss';

const EmptyMessage = ({
    text = '',
    className = '',
    handleClick = () => {},
}) => (
    <div
        className={`component-Users-UserProfile-Modules-EmptyMessage ${className}`}
        onClick={handleClick}
    >
        {text}
    </div>
);

EmptyMessage.propTypes = {
    /**
     * text to be displayed
     */
    text: PropTypes.string.isRequired,
    /**
     * custom styling to override default
     */
    className: PropTypes.string,
    /**
     * handler for clicking empty message
     */
    handleClick: PropTypes.func,
};

export default EmptyMessage;
